import React from 'react';
import { Link } from 'react-router-dom';
import './HotelCard.css';

const HotelCard = ({ hotel }) => {
  const renderStars = (rating) => {
    return Array.from({ length: 5 }, (_, i) => (
      <span key={i} className={`star ${i < Math.floor(rating) ? 'filled' : i < rating ? 'half' : ''}`}>★</span>
    ));
  };

  return (
    <Link to={`/hotels/${hotel._id}`} className="hotel-card">
      <div className="hotel-card-image">
        <img
          src={hotel.photos?.[0] || 'https://images.unsplash.com/photo-1566073771259-6a8506099945?w=600'}
          alt={hotel.name}
          loading="lazy"
        />
        <div className="hotel-card-overlay">
          <span className="hotel-type-badge">{hotel.type}</span>
          {hotel.featured && <span className="featured-badge"> Featured</span>}
        </div>
        <div className="hotel-card-price">
          <span className="price-from">from</span>
          <span className="price-amount">${hotel.cheapestPrice}</span>
          <span className="price-night">/night</span>
        </div>
      </div>
      <div className="hotel-card-body">
        <div className="hotel-card-header">
          <h3 className="hotel-card-name">{hotel.name}</h3>
          <div className="hotel-card-rating">
            <div className="stars">{renderStars(hotel.rating)}</div>
            <span className="rating-num">{hotel.rating?.toFixed(1)}</span>
          </div>
        </div>
        <div className="hotel-card-location">
          <span className="location-icon">📍</span>
          <span>{hotel.city}, {hotel.country}</span>
        </div>
        <p className="hotel-card-desc">{hotel.description?.substring(0, 90)}...</p>
        <div className="hotel-card-amenities">
          {hotel.amenities?.slice(0, 3).map((a, i) => (
            <span key={i} className="amenity-tag">{a}</span>
          ))}
          {hotel.amenities?.length > 3 && (
            <span className="amenity-tag amenity-more">+{hotel.amenities.length - 3}</span>
          )}
        </div>
        <div className="hotel-card-footer">
          <span className="review-count">{hotel.reviewCount?.toLocaleString()} reviews</span>
          <span className="view-btn">Explore →</span>
        </div>
      </div>
    </Link>
  );
};

export default HotelCard;
